import { Component, OnInit } from '@angular/core';
import {AppService} from '../../App/app.service';
import {Location} from '@angular/common';
import {MessageService} from '../message.service';

@Component({
  selector: 'app-level-header',
  templateUrl: './level-header.component.html',
  styleUrls: ['./level-header.component.css']
})
export class LevelHeaderComponent implements OnInit {

  level = 1;
  imgLevelSrc = ['./assets/images/star.png', './assets/images/star.png'];

  constructor(public appService: AppService, protected _location: Location, public messageService: MessageService) {
  }

  ngOnInit() {
  }

  /**
   * Three possible levels for an exercise.
   * Use the correct images for a certain level.
   * @param level - level selected for the exercise
   */
  setLevel(level: number) {
    if (level !== this.level) {
      this.level = level;
      if (this.level === 2) {
        this.imgLevelSrc[0] = './assets/images/star_full.png';
      } else if (this.level === 3) {
        this.imgLevelSrc[0] = './assets/images/star_full.png';
        this.imgLevelSrc[1] = './assets/images/star_full.png';
      }
      this.appService.currentExercise.initValues();
      this.appService.currentExercise.setLevel(level);
    }
  }

  /**
   * Change the image when the mouse go over the stars/levels
   * @param level actual level on which the mouse is.
   */
  changeLevelImgOver(level: number) {
    if (level === 1) {
      this.imgLevelSrc[0] = './assets/images/star.png';
      this.imgLevelSrc[1] = './assets/images/star.png';
    } else if (level === 2) {
      this.imgLevelSrc[0] = './assets/images/star_full.png';
      this.imgLevelSrc[1] = './assets/images/star.png';
    } else if (level === 3) {
      this.imgLevelSrc[0] = './assets/images/star_full.png';
      this.imgLevelSrc[1] = './assets/images/star_full.png';
    }
  }

  /**
   * Get the images for the actual level.
   */
  actualLevelImg() {
    if (this.level === 1) {
      this.imgLevelSrc[0] = './assets/images/star.png';
      this.imgLevelSrc[1] = './assets/images/star.png';
    } else if (this.level === 2) {
      this.imgLevelSrc[0] = './assets/images/star_full.png';
      this.imgLevelSrc[1] = './assets/images/star.png';
    } else if (this.level === 3) {
      this.imgLevelSrc[0] = './assets/images/star_full.png';
      this.imgLevelSrc[1] = './assets/images/star_full.png';
    }
  }


}
